import axios from 'axios';
import {ConcurrencyManager} from "axios-concurrency";
import axiosRetry from "axios-retry";
const baseUrl = process.env.REACT_APP_CARTO_PIA_URL;



const axiosCartoInstance = axios.create({
  baseURL: baseUrl,
});

axiosRetry(axiosCartoInstance, {
  retries: 3,
  retryDelay: (retryCount) => {
    return retryCount * 1000;
  },
  retryCondition: (error) => {
    return (
      axiosRetry.isNetworkError(error) ||
      axiosRetry.isRetryableError(error) ||
      error.response?.status >= 500
    );
  },
});
ConcurrencyManager(axiosCartoInstance, 3);
export default axiosCartoInstance;
